import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=020e99a2&"
import script from "./Billboard.vue?vue&type=script&lang=js&"
export * from "./Billboard.vue?vue&type=script&lang=js&"
import style0 from "./Billboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Billboard.vue"
export default component.exports